export default __webpack_public_path__ + "static/media/modern-slavery-policy.d1f0e617.pdf";